var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { BaseLottery } from '../../base-lottery';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ClientHotLotteriesClientService } from '../../../../../services/modules/client/client-hot-lotteries-client.service';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
var Lottery = /** @class */ (function (_super) {
    __extends(Lottery, _super);
    function Lottery(lotteryClientService, router, tokenClientService, notificationClientService, i18N, hotLotteryClientService, dialogClientService) {
        return _super.call(this, lotteryClientService, router, tokenClientService, notificationClientService, i18N, hotLotteryClientService, dialogClientService) || this;
    }
    Lottery.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showSwitch = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "switch-standard-lottery",
                "switch-syndicate",
                //Colors
                "switch-pages-background",
                "switch-pages-foreground",
                "switch-pages-selected-background",
                "switch-pages-selected-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showCarouselLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "carousel-lotteries-button-play-now",
                "carousel-lotteries-closing-soon",
                //Colors
                "carousel-lotteries-arrow-icon-background",
                "carousel-lotteries-arrow-icon-foreground",
                "carousel-lotteries-jackpot-foreground",
                "carousel-lotteries-play-now-background",
                "carousel-lotteries-play-now-foreground",
                "carousel-lotteries-closing-soon-background",
                "carousel-lotteries-closing-soon-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Colors
                "lotteries-jackpot-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showBanner = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "banner-next-draw",
                //Colors
                "banner-lottery-background",
                "banner-lottery-title-foreground",
                "banner-lottery-prize-foreground",
                "banner-lottery-next-draw-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showGameInformation = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                // Images
                "game-information-image-1",
                "game-information-image-2",
                "game-information-image-3",
                "game-information-image-4",
                //Text
                "game-information-title",
                "game-information-title-1",
                "game-information-desc-1",
                "game-information-title-2",
                "game-information-desc-2",
                "game-information-title-3",
                "game-information-desc-3",
                "game-information-title-4",
                "game-information-desc-4",
                //Colors
                "game-information-title-foreground",
                "game-information-sub-title-foreground",
                "game-information-description-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showPrizeBreakdown = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "prize-breakdown-title",
                "prize-breakdown-prize-tier",
                "prize-breakdown-match",
                "prize-breakdown-odds",
                //Colors
                "prize-breakdown-title-foreground",
                "prize-breakdown-table-title-foreground",
                "prize-breakdown-table-value-foreground",
                "prize-breakdown-table-border",
            ]
        }, window.parent.location.origin);
    };
    Lottery.prototype.showHottestLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "hottest-lotteries-remaning-time",
                "hottest-lotteries-remaning-days",
                "hottest-lotteries-remaning-hours",
                "hottest-lotteries-remaning-minutes",
                "hottest-lotteries-button",
                //Colors
                "hottest-lotteries-title-foreground",
                "hottest-lotteries-background",
                "hottest-lotteries-details-foreground",
                "hottest-lotteries-details-digits-background",
                "hottest-lotteries-details-digits-foreground",
                "hottest-lotteries-prize-currency-foreground",
                "hottest-lotteries-prize-amount-foreground",
                "hottest-lotteries-prize-button-background",
                "hottest-lotteries-prize-button-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lottery = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router,
            TokenClient, NotificationClientService,
            I18N, ClientHotLotteriesClientService, DialogClientService])
    ], Lottery);
    return Lottery;
}(BaseLottery));
export { Lottery };
